export enum UserRoles {
  NetworkAdmin = "it_network_administrator",
  ITAdmin = "it_local_administrator",
  Student = "student",
  ITViewer = "it_viewer",
  DevAdmin = "administrator",
}

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  authToken: string;
  authTokenExpiration: string;
  refreshToken: string;
  refreshTokenExpiration: string;
  /** Role slug as returned by WordPress (e.g. "administrator", "it_local_administrator"). */
  role: string;
  /** Full capabilities map from `/smassets/v1/me` (or normalized from the login response). */
  capabilities?: UserCapabilities;
};

export type UserContextValue = {
  loading?: boolean;
  user?: User | null;
  login: (email: string, password: string) => Promise<User>;
  logout: () => void;
  checkUserAuthentication: () => Promise<true | undefined>;
  capabilities?: UserCapabilities;
};

export type UserCapabilities = Record<string, boolean>;
